import React, { Component } from 'react';
import { FadeIn } from './FadeIn';
export function Contact() {
  return <section id="contact" className="py-32 md:py-44 bg-cream text-charcoal" data-id="element-31">
      <div className="container mx-auto px-6 md:px-12" data-id="element-32">
        <div className="flex flex-col lg:flex-row gap-20 lg:gap-32" data-id="element-33">
          <div className="w-full lg:w-1/3" data-id="element-34">
            <FadeIn direction="right" data-id="element-35">
              <img src="https://code-11.hr/wp-content/uploads/2023/03/logo-i-tekst-1.png" alt="Code 11" className="h-16 w-auto mb-8 opacity-70" data-id="element-36" />
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-37">
                Inquiries
              </span>
              <div className="w-8 h-[1px] bg-copper mb-8" data-id="element-38"></div>
              <h2 className="text-3xl md:text-4xl font-serif mb-12 font-normal" data-id="element-39">
                Begin Your <br data-id="element-40" />
                <span className="italic text-charcoal/60" data-id="element-41">Story</span>
              </h2>

              <div className="space-y-10 font-sans text-sm font-light" data-id="element-42">
                <div data-id="element-43">
                  <h4 className="uppercase tracking-[0.15em] text-xs mb-3 text-charcoal/90" data-id="element-44">
                    Address
                  </h4>
                  <p className="text-charcoal/60 leading-relaxed" data-id="element-45">
                    Code 11 Restaurant
                    <br data-id="element-46" />
                    Mediterranean Coast
                    <br data-id="element-47" />
                    Croatia
                  </p>
                </div>

                <div data-id="element-48">
                  <h4 className="uppercase tracking-[0.15em] text-xs mb-3 text-charcoal/90" data-id="element-49">
                    Contact
                  </h4>
                  <p className="text-charcoal/60 leading-relaxed" data-id="element-50">
                    info@code-11.hr
                    <br data-id="element-51" />
                    +385 91 2911 466
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="w-full lg:w-2/3" data-id="element-52">
            <FadeIn direction="left" delay={0.2} data-id="element-53">
              <form className="bg-white p-10 md:p-16 border border-charcoal/5" onSubmit={e => {
              e.preventDefault();
              const form = e.currentTarget as HTMLFormElement;
              const data = new FormData(form);
              const name = data.get('name') as string || '';
              const email = data.get('email') as string || '';
              const date = data.get('weddingDate') as string || '';
              const message = data.get('message') as string || '';
              const subject = encodeURIComponent(`Wedding Inquiry from ${name || 'Website Visitor'}`);
              const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\nWedding Date: ${date}\n\nMessage:\n${message}`);
              window.location.href = `mailto:info@code-11.hr?subject=${subject}&body=${body}`;
            }} data-id="element-54">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 mb-12" data-id="element-55">
                  <div data-id="element-56">
                    <label className="block font-sans text-[10px] uppercase tracking-[0.2em] text-charcoal/40 mb-3" data-id="element-57">
                      Name
                    </label>
                    <input name="name" type="text" required className="w-full border-b border-charcoal/10 py-2 bg-transparent focus:outline-none focus:border-charcoal/40 transition-colors font-sans text-sm font-light" data-id="element-58" />
                  </div>
                  <div data-id="element-59">
                    <label className="block font-sans text-[10px] uppercase tracking-[0.2em] text-charcoal/40 mb-3" data-id="element-60">
                      Email
                    </label>
                    <input name="email" type="email" required className="w-full border-b border-charcoal/10 py-2 bg-transparent focus:outline-none focus:border-charcoal/40 transition-colors font-sans text-sm font-light" data-id="element-61" />
                  </div>
                  <div className="md:col-span-2" data-id="element-62">
                    <label className="block font-sans text-[10px] uppercase tracking-[0.2em] text-charcoal/40 mb-3" data-id="element-63">
                      Wedding Date
                    </label>
                    <input name="weddingDate" type="text" className="w-full border-b border-charcoal/10 py-2 bg-transparent focus:outline-none focus:border-charcoal/40 transition-colors font-sans text-sm font-light" data-id="element-64" />
                  </div>
                  <div className="md:col-span-2" data-id="element-65">
                    <label className="block font-sans text-[10px] uppercase tracking-[0.2em] text-charcoal/40 mb-3" data-id="element-66">
                      Message
                    </label>
                    <textarea name="message" rows={3} className="w-full border-b border-charcoal/10 py-2 bg-transparent focus:outline-none focus:border-charcoal/40 transition-colors font-sans text-sm font-light resize-none" data-id="element-67"></textarea>
                  </div>
                </div>
                <button type="submit" className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/80 hover:text-charcoal transition-colors border-b border-charcoal/30 hover:border-charcoal pb-1 inline-block" data-id="element-68">
                  Send Inquiry
                </button>
              </form>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}